var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.startRender && _vm.animation)?_c('Transition',{attrs:{"name":_vm.nameAnim}},[_vm._t("default")],2):_c('div',[(_vm.startRender)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }